import './sectionCareersSlider.scss';

export default (() => {
	$(document).ready(function () {
		$('.careers-slider__inner').owlCarousel({
			items: 1,
			loop: true,
			center: true,
			margin: -100,
			dots: true,
			stagePadding: 40,
			nav: false,
			video: true,
			lazyLoad: true,
			responsive: {
				480: {
					stagePadding: 60
				}
			}
		});
	});
})();
